import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePopup } from '../context/PopupContext';

const useRouteChange = () => {
    const location = useLocation();
    const { handleAutomatedPopup } = usePopup();
    const lastPathRef = useRef(location.pathname);
    const isInitialMount = useRef(true);
    const [isRouteReady, setIsRouteReady] = useState(false);

    useEffect(() => {
        // Marquer la route comme prête après un court délai pour le premier chargement
        if (isInitialMount.current) {
            isInitialMount.current = false;
            // Utiliser requestAnimationFrame pour s'assurer que le DOM est prêt
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setIsRouteReady(true);
                });
            });
            return;
        }

        // Pour les changements de route, marquer immédiatement comme prêt
        if (lastPathRef.current !== location.pathname) {
            lastPathRef.current = location.pathname;
            setIsRouteReady(true);
        }
    }, [location.pathname]);

    useEffect(() => {
        // Déclencher le popup seulement quand la route est prête
        if (isRouteReady) {
            handleAutomatedPopup();
            setIsRouteReady(false);
        }
    }, [isRouteReady, handleAutomatedPopup]);
};

export default useRouteChange; 